// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  ICompanyGetListAttrs,
  ICompanyGetDetailAttrs,
  ICompanyUpdateAttrs,
  ICompanyGetDropdownAttrs,
} from 'interfaces/back-office/master/company/company-view.interface'

const useMasterCompany = () => {
  const {
    masterCompany: {
      masterCompany_loading,
      masterCompany_list,
      masterCompany_detail,
      masterCompany_dropdown,
      masterCompany_CLEAR_LIST,
      masterCompany_CLEAR_DETAIL,
      masterCompany_CLEAR_DROPDOWN,
      masterCompany_fetchList: fetchList,
      masterCompany_fetchDetail: fetchDetail,
      masterCompany_update: update,
      masterCompany_fetchDropdown: fetchDropdown,
    },
  } = useStores()

  /**
   * @description Get company list
   *
   * @param {ICompanyGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterCompany_fetchList = useCallback(
    async (payload: ICompanyGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchList],
  )

  /**
   * @description Get company detail
   *
   * @param {ICompanyGetDetailAttrs} payload
   *
   * @return {void} void
   */
  const masterCompany_fetchDetail = useCallback(
    async (payload: ICompanyGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  /**
   * @description Update Company
   *
   * @param {ICompanyUpdateAttrs} payload
   *
   * @return {void} void
   */
  const masterCompany_update = useCallback(
    async (payload: ICompanyUpdateAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        update({
          params: { ...payload.params },
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [update],
  )

  /**
   * @description Get company dropdown
   *
   * @param {ICompanyGetDropdownAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterCompany_fetchDropdown = useCallback(
    async (payload: ICompanyGetDropdownAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDropdown({
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDropdown],
  )

  return {
    masterCompany_loading,
    masterCompany_list,
    masterCompany_detail,
    masterCompany_dropdown,
    masterCompany_CLEAR_LIST,
    masterCompany_CLEAR_DETAIL,
    masterCompany_CLEAR_DROPDOWN,
    masterCompany_fetchList,
    masterCompany_fetchDetail,
    masterCompany_update,
    masterCompany_fetchDropdown,
  }
}

export { useMasterCompany }
